const RememberKey = 'scm_mobile_remember';

export function getData() {
  try {
    const value = localStorage.getItem(RememberKey);
    const data = JSON.parse(value);
    return data;
  } catch {
    return null;
  }
}

export function saveData(data) {
  const value = JSON.stringify(data);
  localStorage.setItem(RememberKey, value);
}
